import $ from 'jquery'

let remove = () => {
    $('body > .pop-wrap-bg').remove(); 
}

let out = () => {
    $('body > .pop-wrap-bg').addClass('out'); 
    setTimeout(() => {
        $('body > .pop-wrap-bg').remove(); 
    }, 250);
}

export default {
    show(html = '',showClose = false){
        remove();
        const $pop = $(`<div class="pop-wrap-bg">${showClose?'<a href="#" class="iconfont pop-close-btn">&#xe651;</a>':''}</div>`).append(html);
        $pop.find('.pop-close-btn').click(()=>{
            out();
            return false;
        })
        $('body').append($pop);
        return $pop;
    },
    hide:remove
}